module.exports = __webpack_public_path__ + "img/dev.9f8f495b.png";